<script setup lang="ts">
import { watch, onMounted } from 'vue'
import { useForm } from 'vee-validate'
import Dropdown from '@/components/Globals/Inputs/Dropdown.vue'
import type { ISensorFormData } from '@/interfaces/components/createSensor/create-sensor'
import { SensorType } from '@/interfaces/enums'

const props = defineProps<{
  modelValue: ISensorFormData
  typeOptions: Array<{ id: string; name: string }>
  manufacturerOptions: Array<{ id: string; name: string }>
  initialValues: { sensor_type: object | null; manufacturer: object | null }
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: ISensorFormData): void
  (e: 'validate', isValid: boolean): void
}>()

const { meta, setFieldValue, setValues } = useForm()

watch(
  () => meta.value.valid,
  (valid) => {
    emit('validate', !!valid)
  },
  { immediate: true },
)

onMounted(() => {
  setValues(props.initialValues)
})

watch(
  () => props.initialValues,
  (val) => {
    setValues(val)
  },
  { deep: true },
)

function handleTypeSelected(option: { id: string; name: string } | null) {
  if (!option) return
  setFieldValue('sensor_type', option)
  emit('update:modelValue', { ...props.modelValue, sensor_type: option.id as SensorType })
}

function handleManufacturerSelected(option: { id: string; name: string } | null) {
  if (!option) return
  setFieldValue('manufacturer', option)
  emit('update:modelValue', { ...props.modelValue, manufacturer: option.id })
}
</script>

<template>
  <div class="space-y-6">
    <div class="space-y-1.5">
      <label class="block text-sm font-semibold text-slate-700 dark:text-gray-300">Tipo de Sensor</label>
      <Dropdown
        name="sensor_type"
        placeholder="Selecione o tipo"
        label-attribute="name"
        :options="typeOptions"
        :already-selected-option="typeOptions.find((o) => o.id === modelValue.sensor_type)"
        @option-selected="handleTypeSelected"
      />
    </div>
    <div class="space-y-1.5">
      <label class="block text-sm font-semibold text-slate-700 dark:text-gray-300">Modelo (Fabricante)</label>
      <Dropdown
        name="manufacturer"
        placeholder="Selecione o fabricante"
        label-attribute="name"
        :options="manufacturerOptions"
        :already-selected-option="manufacturerOptions.find((o) => o.id === modelValue.manufacturer)"
        @option-selected="handleManufacturerSelected"
      />
    </div>
  </div>
</template>
